const hookInputSetter = (target, key) => {
    const orig = Object.getOwnPropertyDescriptor(target, key);
    Object.defineProperty(target, key, {
        set(value) {
            this.dispatchEvent(new Event("coherevalueupdate"));
            if (orig && orig.set) {
                orig.set.call(this, value);
            }
        },
    });
};

const disableLoad = typeof window === "undefined" ||
    !window.document ||
    window.document.documentMode;
if (!disableLoad) {
    hookInputSetter(HTMLInputElement.prototype, "value");
    hookInputSetter(HTMLInputElement.prototype, "checked");
    hookInputSetter(HTMLTextAreaElement.prototype, "value");
    hookInputSetter(HTMLSelectElement.prototype, "value");
    hookInputSetter(HTMLSelectElement.prototype, "selectedIndex");
}
const bridgedMethods = ["init", "identify", "stop", "showCode"];
const noop = () => { };
const noopModule = {
    init: noop,
    identify: noop,
    stop: noop,
    showCode: noop,
};
// Create cohere or pass in previous args to init/initialize
//  if script is not created
let Cohere = disableLoad
    ? noopModule
    : (window.Cohere = []);
if (!disableLoad) {
    Cohere.invoked = true;
    Cohere.snippet = "0.4";
    Cohere.valhook = true;
    Cohere.methods = bridgedMethods;
    Cohere.methods.forEach((method) => {
        Cohere[method] = (...args) => {
            args.unshift(method);
            Cohere.push(args);
        };
    });
    // Create an async script element based on your key
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    script.src = "https://static.cohere.so/main.js";
    // Insert our script before the first script element
    const first = document.getElementsByTagName("script")[0];
    if (first && first.parentNode) {
        first.parentNode.insertBefore(script, first);
    }
}
const exportedModule = Cohere;

export default exportedModule;
